import styled from '@emotion/styled';

import wash from 'storybookConfig/mixins/wash';
import ShaderBackground, {
  type ShaderPalette,
} from 'storybookConfig/stories/molecules/ShaderBackground';
import type { ThemeWash } from 'storybookConfig/stories/theme';

interface WashFieldProps {
  /** The wash that sets the composition. */
  wash: ThemeWash;
  /** The still plasma field laid over it in soft light, for depth and the shader's grain. */
  palette: ShaderPalette;
  /** `absolute` fills a positioned parent and takes its radius; `fixed` covers the viewport. */
  position?: 'absolute' | 'fixed';
}

const Field = styled.div<{ $wash: ThemeWash; $position: 'absolute' | 'fixed' }>`
  position: ${({ $position }) => $position};
  inset: 0;
  overflow: hidden;
  border-radius: inherit;
  ${({ $wash }) => wash($wash)};
`;

const Texture = styled.div`
  position: absolute;
  inset: 0;
  mix-blend-mode: soft-light;
`;

/**
 * A decorative ground: a wash with a still plasma field over it in soft light. Account onboarding
 * and the sidebar announcements sit on it. The wash shows on its own before the field draws and
 * without WebGL.
 */
const WashField = ({ wash: name, palette, position = 'absolute' }: WashFieldProps) => (
  <Field $wash={name} $position={position} aria-hidden>
    <Texture>
      <ShaderBackground palette={palette} zoom={0.5} still />
    </Texture>
  </Field>
);

export default WashField;
